import React from "react";
import { makeStyles } from "@mui/styles";
import {
    Grid,
    Paper,
    Typography,
    TextField,
    Radio,
    RadioGroup,
    FormControlLabel,
    Button,
    Divider,
  } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '50%',
        height: '550px',
        alignItems: 'center',
        display: 'flex', 
        justifyContent: 'center'
    },
    formContainer: {
      width: 'auto',
      height: 'auto',
      padding: theme.spacing(2),
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
    submitButton: {
      backgroundColor: '#1F4A7C', 
      color: 'white',
      '&:hover': {
        backgroundColor: '#45a049',
      },
      marginTop: '20px',
      borderRadius: '5px'
    },
  }));

const ComplaintForm = () => {
    const classes = useStyles()
    return(
        <div className={classes.root}>
        <Paper elevation={3} className={classes.formContainer}>
        <Typography variant="h5" gutterBottom style={{color: '#2F5EA8'}}>
          Feedback / Complaint Form
        </Typography>
        <form className={classes.form}>
          <RadioGroup defaultValue="feedback" aria-label="feedback-type" name="feedbackType" style={{display: 'flex', flexDirection: 'row', textAlign: 'center'}}>
            <FormControlLabel value="feedback" control={<Radio />} label="Feedback" />
            <FormControlLabel value="complaint" control={<Radio />} label="Complaint" />
          </RadioGroup>
          <TextField label="Name" variant="outlined" required />
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField label="Mobile No" variant="outlined" required />
            </Grid>
            <Grid item xs={6}>
              <TextField label="Email" variant="outlined" required />
            </Grid>
          </Grid>
          <TextField label="Subject" variant="outlined" required />
          <TextField
            label="Enter your message"
            variant="outlined"
            multiline
            minRows={2}
            required
          />
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={6}>
              <TextField label="Enter captcha" variant="outlined" required />
            </Grid>
            <Grid item xs={6}>
              <Typography variant="h6" align="center">
                Captcha- WIP
              </Typography>
            </Grid>
          </Grid>
          <Button
            type="submit"
            variant="contained"
            className={classes.submitButton}
            style={{backgroundColor: '#4BAB58'}}
          >
            Submit
          </Button>
        </form>
      </Paper>
      </div>
    )
}

export default ComplaintForm